import { Grid, Skeleton } from "@mantine/core";
import PageWrapperSkeleton from "../common/PageWrapperSkeleton";
import ExpertCardSkeleton from "../experts/ExpertCardSkeleton";
import ExpertSmallCardSkeleton from "../experts/ExpertSmallCardSkeleton";

const HomePageExpertsSkeleton = () => {
  return (
    <>
      <PageWrapperSkeleton>
        <Grid gutter={0}>
          {Array.from(Array(8).keys()).map((expert, index) => (
            <Grid.Col span={12} md={6} lg={12} m={0} key={index}>
              <div className="hidden lg:block">
                <ExpertCardSkeleton />
              </div>
              <div className="block lg:hidden">
                <ExpertSmallCardSkeleton />
              </div>
            </Grid.Col>
          ))}
        </Grid>
      </PageWrapperSkeleton>
      <div className="flex justify-center my-[54px]">
        <Skeleton height={50} width={149} />
      </div>
    </>
  );
};

export default HomePageExpertsSkeleton;
